export default __webpack_public_path__ + "static/media/table-print-icon.c3459ec2.svg";